<template>
  <div>
    <v-tabs
      v-model="tab"
      class="home-tabs"
      align-with-title
    >
      <!--      <v-tabs-slider color="yellow"></v-tabs-slider>-->
      <v-tab href="#home-tab" to="/home-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_request_grey.svg" />
          <p class="home-tabs-title">ثبت درخواست</p>
        </div>
      </v-tab>
      <v-tab href="#profile-tab" to="/report-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_report_blue.svg" />
          <p class="home-tabs-title">گزارش درخواست</p>
        </div>
      </v-tab>
      <v-tab href="#message-tab" to="/message-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_messenger_grey.svg" />
          <p class="home-tabs-title">پیام رسان</p>
        </div>
      </v-tab>
      <v-tab href="#profile-tab" to="/profile-tab">
        <div>
          <img style="width: 30px" src="/img/bottom_icon/bottom_account_grey.svg" />
          <p class="home-tabs-title">پروفایل</p>
        </div>
      </v-tab>
      <v-tabs-items>
        <v-card flat>
          <v-card-text >
            <div class="row requests" v-if="$i18n.locale=='fa'">

              <div class="col-6">
                <span v-on:click="go_to_report_question(false)">
                  <img src="../../../public/img/report_questions.png" />
                </span>
              </div>
              <div class="col-6">
                <span v-on:click="go_to_my_requests(true)">
                  <img src="../../../public/img/report_requests.png" />
                </span>
              </div>

            </div>
            <div class="row requests" v-if="$i18n.locale=='en'">

              <div class="col-6">
                <span v-on:click="go_to_report_question(false)">
                  <img src="../../../public/img/report_questions_tr.png" />
                </span>
              </div>
              <div class="col-6">
                <span v-on:click="go_to_my_requests(true)">
                  <img src="../../../public/img/report_requests_tr.png" />
                </span>
              </div>

            </div>
          </v-card-text>
        </v-card>
      </v-tabs-items>
    </v-tabs>
  </div>

</template>
<script>
  import { bus } from '../../main.js'
  export default {
    data () {
      return {
        tab: null,
        accept_device: false,
      }
    },
mounted () {
    this.check_accept_device()
      },
    methods:{
      go_to_customer_info (OnSite) {
        var PassingData = { on_site_service:OnSite }
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        // this.$store.commit('set', ['request_data', PassingData])
        // this.$store.commit('toggleSidebarDesktop')
        // console.log(store.state.count) //
        this.$router.push({ name:'CustomerInfo', params:{} })
      },
      go_to_my_requests () {
        this.$router.push({ name:'MyRequests', params:{} })
      },
go_to_report_question () {
        this.$router.push({ name:'MyQuestions', params:{} })
      },
go_to_report_referred_requests () {
        this.$router.push({ name:'ReportReferredRequest', params:{} })
      },
      go_to_safir_devices () {
        this.$router.push({ name:'SafirDevices', params:{} })
      },

      check_accept_device () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CheckAcceptDevice', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.accept_device = true
            } else {
              self.accept_device = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
